export default __webpack_public_path__ + "static/media/mapFrameSmall.c5ee94cd.png";